export const DEFAULT_DRAWER_DETAIL_WIDTH = 1120;

export const DRAWER_WIDTH_STORAGE_KEY =
  'adminInvoiceReportDetailDrawerWidth:v1';
